export const EightByEightFormItemKeys = {
    campaignName: "campaignName",
    campaignId: "campaignId",
};

export const VoicemailFormItemKeys = {
    voicemailId: "voicemailId",
    voicemailDisplayName: "voicemailDisplayName",
    voicemailFilename: "voicemailFilename",
};

export const AgentlessCallFormItemKeys = {
    ivrId: "ivrId",
    ivrName: "ivrName",
};

export const VoiceAIFormItemKeys = {
    voiceAIID: "voiceAIID",
    voiceAIName: "voiceAIName",
};

export const GenesysFormItemKeys = {
    genesysID: "genesysID",
    genesysName: "genesysName",
};

export const TalkdeskFormItemKeys = {
    talkdeskID: "talkdeskID",
    talkdeskName: "talkdeskName",
};

export const NiceFormItemKeys = {
    niceID: "niceID",
    niceName: "niceName",
};

export const Five9FormItemKeys = {
    five9ID: "five9ID",
    five9Name: "five9Name",
};

export const SMSAIFormItemKeys = {
    smsAIID: "smsAIID",
    smsAIName: "smsAIName",
};

export const CustomAITaskFormItemKeys = {
    customAITaskName: "customAITaskName",
    customAITaskInput: "customAITaskInput",
    customAITaskPrompt: "customAITaskPrompt",
};

export const DecisionAIFormItemKeys = {
    decisionType: "decisionType",
    name: "name",
    model: "model",
    prompt: "prompt",
    variants: "variants",
};

export const DecisionAIVariantFormItemKeys = {
    name: "name",
    description: "description",
};

export const SendEmailFormItemKeys = {
    sendEmailID: "emailID",
    sendEmailName: "emailName",
};

export const CreateEmailTaskFormItemKeys = {
    createEmailTaskID: "createEmailTaskID",
    createEmailTaskName: "createEmailTaskName",
};
